module.exports = __webpack_public_path__ + "0e020244cbc886430bc2d9aa20c95679.svg";